var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33333C4.32004 1.33333 1.33337 4.32 1.33337 8C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8.00004 1.33333ZM7.33337 13.2867C4.70004 12.96 2.66671 10.72 2.66671 8C2.66671 7.58666 2.72004 7.19333 2.80671 6.80666L6.00004 10V10.6667C6.00004 11.4 6.60004 12 7.33337 12V13.2867ZM11.9334 11.5933C11.76 11.0533 11.2667 10.6667 10.6667 10.6667H10V8.66666C10 8.3 9.70004 8 9.33337 8H5.33337V6.66666H6.66671C7.03337 6.66666 7.33337 6.36666 7.33337 6V4.66666H8.66671C9.40004 4.66666 10 4.06666 10 3.33333V3.06C11.9534 3.85333 13.3334 5.76666 13.3334 8C13.3334 9.38666 12.8 10.6467 11.9334 11.5933Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIp);
export default __webpack_public_path__ + "static/media/ip.12ac36eb550ce84a0f57e2606c90f9dc.svg";
export { ForwardRef as ReactComponent };